<template>
    <v-chip label outlined :text="!button" depressed v-if="url" @click.stop="goto" v-bind="$attrs" :class="{'caption' : dense, 'pa-0' : !button && dense}" style="text-transform: none;font-weight:normal;background-color: transparent;border:0" :style="dense && !button ? 'height:auto' : ''">
        <template >
                  <v-icon :small="dense" class="mr-2" v-if="icon">{{icon}}</v-icon>
                        <slot>{{title}}</slot>
                  </template>
      </v-chip>
          <v-chip label outlined :text="!button" depressed v-else v-bind="$attrs" @click="$emit('click')" :class="{'caption' : dense, 'pa-0' : !button && dense}" style="text-transform: none;font-weight:normal;background-color: transparent;border:0"  :style="dense && !button ? 'height:auto' : ''">
        <template>
          <v-icon :small="dense"  class="mr-2" v-if="icon">{{icon}}</v-icon>
                <slot>{{title}}</slot>
          </template>
      </v-chip>                            
</template>
<script>

export default {
   props: {
    value: {
      type: String,
      default: function () {
        return null
      },
    },
    icon:{
        type: String,
        default: function () {
          return null
        },
      },
    label:{
        type: String,
        default: function () {
          return null
        },
      },
      dense:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      button:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      email:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      phone:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      location:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      secure:{
        type: Boolean,
        default: function () {
          return false
        },
      }
   },
  data: () => ({
     
  }),
  computed: {
    prefix(){
        if (this.email) return 'mailto:'
        if (this.phone) return 'callto:'
        if (this.location) return 'https://www.google.com/maps/search/'
        if (this.secure) return 'https://'
        return 'http://'
    },
    title() {
        return this.label || this.value
    },
    url(){
      if (!this.value) return null
      if (this.value.includes(':')) return this.value
      return this.prefix + this.value
    },
  },
  mounted () {
   
  },
watch: {

},
methods: {
  goto(){
    window.open(this.url)
  }
}
}

</script>